module.exports = __webpack_public_path__ + "img/img.48a31ac0.gif";